// @ts-ignore - no types for ar-style-base
import { WizardProgressHeader } from '@nextroll/ar-style-base';

import { SignUpModes } from '../../constants';
import EmailVerificationForm from '../../forms/email-verification/EmailVerificationForm';

const ShopifyEmailVerificationPage = () => {
    return (
        <section className='eh-page-shopify-email-verification'>
            <div className='eh-shopify-sign-up-topbar'>
                <WizardProgressHeader currentStep={2} totalSteps={5} />
            </div>

            <section className='eh-page eh-page-email-verification'>
                <EmailVerificationForm mode={SignUpModes.SHOPIFY} />
            </section>
        </section>
    );
};

export default ShopifyEmailVerificationPage;
